/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import Calculate from "components/payments/Calculator";
import Formmoneypay from "components/payments/Inputmoneypay";

export default function PayCash({
  payment,
  money,
  actions,
  order,
  ui,
  ...props
}) {
  const { amount, setAmount } = money;
  const { addPayment, handleCompletePayment } = actions;
  const { details } = order;
  const { buttons } = ui;

  const isPaymentSuccess =
    parseFloat(details.paymentTotal) >= parseFloat(details.paymentNet);

  const isZeroAmount = parseFloat(amount) === 0;

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isZeroAmount && !isPaymentSuccess) {
      addPayment();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [amount, isPaymentSuccess]);

  return (
    <>
      <div className="d-flex align-items-center text-[#061126] mb-1">
        <div className="me-auto">
          <span className="fs-18 fw-500">Order NO.</span>
          <span className="fs-14 fw-500 ms-2">{details?.orderNo || ""}</span>
        </div>
        <div className="fs-18 fw-bold text-[#2DC76D]">ชำระเงินสด</div>
      </div>

      <div className="fs-14 fw-500 mb-3">กรุณาระบุยอดเงินรับชำระ</div>

      <div className="py-2">
        <Formmoneypay moneypay={amount} setMoneypay={setAmount} />
      </div>

      <Calculate
        setMoneypay={setAmount}
        moneypay={amount}
        PaymentDetail={details}
      />

      <div className="d-flex align-items-center pt-2">
        <button
          className="me-auto btn btn-st-q1 px-5"
          onClick={addPayment}
          disabled={isPaymentSuccess || isZeroAmount}
        >
          Enter
        </button>
        <button
          className="btn btn-st-q1"
          onClick={handleCompletePayment}
          disabled={buttons.paymentDisabled}
        >
          ชำระเงิน
        </button>
      </div>
    </>
  );
}
